"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var __1 = require("../../..");
var RelatedTreeSelect_1 = require("../../molecules/RelatedTreeSelect");
var formik_1 = require("formik");
var react_i18next_1 = require("react-i18next");
var styled_components_1 = __importStar(require("styled-components"));
var Header = styled_components_1.default.header(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding-bottom: 18px;\n  border-bottom: 1px solid ", ";\n  margin-bottom: 24px;\n"], ["\n  padding-bottom: 18px;\n  border-bottom: 1px solid ", ";\n  margin-bottom: 24px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.primaryColor;
});
var AddTaskWrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  & form {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n  }\n"], ["\n  & form {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n  }\n"])));
var ButtonsWrapper = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 26px;\n"], ["\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 26px;\n"])));
var ModalAddTask = function (_a) {
    var onSuccess = _a.onSuccess, onError = _a.onError, onCancel = _a.onCancel, addTask = _a.addTask, refreshTasks = _a.refreshTasks;
    var initialValues = {
        title: "",
    };
    var t = (0, react_i18next_1.useTranslation)().t;
    var validate = function (values) {
        var errors = {};
        if (!values.title) {
            errors.title = "Required";
        }
        return errors;
    };
    return ((0, jsx_runtime_1.jsxs)(AddTaskWrapper, { children: [(0, jsx_runtime_1.jsx)(Header, { children: (0, jsx_runtime_1.jsx)(__1.Title, { children: t("Tasks.AddNewTask") }) }), (0, jsx_runtime_1.jsx)(formik_1.Formik, __assign({ initialValues: initialValues, validate: validate, onSubmit: function (_a, _b) {
                    var related = _a.related, values = __rest(_a, ["related"]);
                    var setSubmitting = _b.setSubmitting, resetForm = _b.resetForm, setErrors = _b.setErrors;
                    var sendValues = __assign({}, values);
                    if (related && related.includes(":")) {
                        var _c = related.split(":"), related_type = _c[0], related_id = _c[1];
                        sendValues = __assign(__assign({}, sendValues), { related_type: related_type, related_id: related_id });
                    }
                    addTask(sendValues)
                        .then(function () {
                        refreshTasks();
                        resetForm();
                        onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
                    })
                        .catch(function (err) {
                        var _a;
                        setErrors(__assign({ error: (_a = err === null || err === void 0 ? void 0 : err.data) === null || _a === void 0 ? void 0 : _a.message }, err.data.errors));
                        onError === null || onError === void 0 ? void 0 : onError(err);
                    })
                        .finally(function () {
                        setSubmitting(false);
                    });
                } }, { children: function (_a) {
                    var values = _a.values, errors = _a.errors, touched = _a.touched, handleChange = _a.handleChange, handleBlur = _a.handleBlur, handleSubmit = _a.handleSubmit, setFieldValue = _a.setFieldValue, isSubmitting = _a.isSubmitting;
                    return ((0, jsx_runtime_1.jsxs)("form", __assign({ onSubmit: handleSubmit }, { children: [(0, jsx_runtime_1.jsx)(__1.Input, { error: touched.title && errors.title ? ((0, jsx_runtime_1.jsx)("p", { children: errors.title })) : undefined, label: t("Tasks.Title"), placeholder: t("Tasks.Title"), type: "text", name: "title", onChange: handleChange, onBlur: handleBlur, value: values.title, required: true }), (0, jsx_runtime_1.jsx)(__1.Input, { error: touched.description && errors.description ? ((0, jsx_runtime_1.jsx)("p", { children: errors.description })) : undefined, label: t("Tasks.Description"), placeholder: t("Tasks.Description"), type: "text", name: "description", onChange: handleChange, onBlur: handleBlur, value: values.description }), (0, jsx_runtime_1.jsx)(RelatedTreeSelect_1.RelatedTreeSelect, { id: "related-tree-select", label: t("Tasks.RelatesTo"), notFoundContent: t("Tasks.NoContent"), value: values.related, onChange: function (v) { return setFieldValue("related", v); }, onBlur: handleBlur }), (0, jsx_runtime_1.jsxs)(ButtonsWrapper, { children: [(0, jsx_runtime_1.jsx)(__1.Button, __assign({ type: "button", mode: "secondary", onClick: onCancel }, { children: t("Tasks.Cancel") })), (0, jsx_runtime_1.jsx)(__1.Button, __assign({ type: "submit", mode: "secondary", disabled: isSubmitting }, { children: t("Tasks.Submit") }))] })] })));
                } }))] }));
};
exports.default = (0, styled_components_1.withTheme)((0, styled_components_1.default)(ModalAddTask)(templateObject_4 || (templateObject_4 = __makeTemplateObject([""], [""]))));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
